import React from 'react'

const ChatGpt = () => {
  return (
    <span style={{fontsize: 33, backgroundColor: "orange"}}>Check out <a href="https://alvs-chat-gpt-ai-app-five.vercel.app/" target="_blank" style={{fontsize: 22 }}>ChatGpt</a>.</span>

  )
}

export default ChatGpt